import { Check, X } from "lucide-react";

const ROWS = [
  ["Website", true, "Vendor A"],
  ["SEO & content", true, "Vendor B"],
  ["Paid ads & lead gen", true, "Vendor C"],
  ["CRM + sales ops", true, "Vendor D"],
  ["WhatsApp + email automation", true, "Vendor E"],
  ["AI workflows & internal tools", true, "Almost nobody"],
];

export default function WhyUs() {
  return (
    <section
      id="about"
      data-testid="why-us-section"
      className="py-20 md:py-32 border-b hairline"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-y-12 md:gap-x-16">
        <div className="col-span-12 md:col-span-5">
          <div className="section-label mb-4">
            <span className="dot" /> Why CyberCart
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] text-balance">
            Five vendors. Five invoices. <br />
            <span className="font-serif-accent italic font-normal">
              Zero ownership.
            </span>
          </h2>
          <p className="mt-6 text-[color:var(--ink-2)] leading-relaxed max-w-md">
            That's the reality for most Mumbai businesses we meet. CyberCart is
            built to be the opposite — one accountable partner that owns the
            outcome from your first click to a closed deal.
          </p>
          <ul className="mt-8 space-y-3 text-sm">
            {[
              "One project lead. One Slack channel. One invoice.",
              "Fixed-price builds, transparent monthly retainers.",
              "Weekly reporting in plain English, not jargon.",
              "Code, data and accounts always owned by you.",
            ].map((line) => (
              <li key={line} className="flex items-start gap-3">
                <span
                  className="mt-1 inline-block w-3 h-3 rounded-sm"
                  style={{ background: "var(--accent)" }}
                />
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-12 md:col-span-7">
          <div className="border hairline rounded-lg overflow-hidden bg-white shadow-soft">
            <div className="grid grid-cols-12 px-5 py-3 text-xs uppercase tracking-[0.2em] text-[color:var(--ink-2)] border-b hairline">
              <div className="col-span-6">Capability</div>
              <div className="col-span-3 text-center">CyberCart</div>
              <div className="col-span-3 text-center">Typical agency</div>
            </div>
            {ROWS.map(([cap, mine, theirs]) => (
              <div
                key={cap}
                className="grid grid-cols-12 px-5 py-4 border-b hairline last:border-b-0 items-center"
              >
                <div className="col-span-6 text-sm md:text-base">{cap}</div>
                <div className="col-span-3 flex justify-center">
                  <span
                    className="inline-flex items-center gap-2 text-xs md:text-sm font-medium"
                    style={{ color: "var(--accent)" }}
                  >
                    <Check className="w-4 h-4" /> In-house
                  </span>
                </div>
                <div className="col-span-3 text-center text-xs md:text-sm text-[color:var(--ink-2)]">
                  <span className="inline-flex items-center gap-2">
                    <X className="w-4 h-4 opacity-60" /> {theirs}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              ["Mumbai HQ", "On-ground, in your timezone"],
              ["Senior team", "No juniors on critical work"],
              ["NDA-ready", "Your data, locked down"],
              ["Outcome-first", "Tied to your revenue"],
            ].map(([t, s]) => (
              <div
                key={t}
                className="p-4 border hairline rounded-md bg-[color:var(--bg)]"
              >
                <div className="text-sm font-medium">{t}</div>
                <div className="text-xs text-[color:var(--ink-2)] mt-1">{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
